module.exports = __webpack_public_path__ + "static/media/Unicatalog Logo en.22af6078.svg";